// extracted by mini-css-extract-plugin
module.exports = {"errors":"style_errors__1qPXG","container":"style_container__1J5wN","footerNav":"style_footerNav__1hWJN"};